// extracted by mini-css-extract-plugin
module.exports = {"button":"PublicSubmitButton_button__48Nx8","border":"PublicSubmitButton_border__XTbek","arrow":"PublicSubmitButton_arrow__1fjEJ"};